<div class="sheet">
  @if (formGroup) {
    <form id="pickup" [formGroup]="formGroup" (ngSubmit)="confirm()">
      <div class="line">
        <h4>{{ 'PICKUP.TITLE' | translate }}</h4>
        <img class="icon-xl" (click)="close()" [src]="'close.svg' | themeSource">
      </div>

      @for (field of fields; track field) {
        @switch (field.type) {
          @case ('phone') {
            <mat-form-field>
              <mat-label>{{ field.name }}</mat-label>
              <ngx-mat-input-tel
                [preferredCountries]="['AE']"
                [defaultCountry]="'AE'"
                [enablePlaceholder]="true"
                [enableSearch]="true"
                name="phone"
                describedBy="phoneInput"
                [formControlName]="field.key"
                [required]="field.required">
              </ngx-mat-input-tel>
              @let phoneErrors = formGroup.controls[field.key].errors;
              @if (phoneErrors && submitted) {
                <mat-error>
                  @if (phoneErrors.required) {
                    {{ 'COMMON.REQUIRED' | translate }}!
                  } @else if (phoneErrors.validatePhoneNumber) {
                    {{ 'COMMON.INVALID_PHONE' | translate }}
                  }
                </mat-error>
              }
            </mat-form-field>
          }
          @case ('radio') {
            @let radioInvalid = formGroup.controls[field.key].errors !== null && submitted;
            <div class="field-group" [class.invalid]="radioInvalid">
              <mat-label>{{ field.name }}</mat-label>
              <mat-radio-group [formControlName]="field.key" [required]="field.required" [color]="radioInvalid ? 'warn' : 'primary'">
                @for (rawOption of field.options; track $index) {
                  @let option = toOption(rawOption);
                  <mat-radio-button [value]="option.key">
                    <span class="radio-option">{{ option.value }}</span>
                  </mat-radio-button>
                }
              </mat-radio-group>
              @if (radioInvalid) {
                <p class="required-label">{{ 'COMMON.REQUIRED' | translate }}!</p>
              }
            </div>
          }
          @case ('select') {
            <mat-form-field>
              <mat-label>{{ field.name }}</mat-label>
              <mat-select [formControlName]="field.key" [required]="field.required">
                @for (rawOption of field.options; track $index) {
                  @let option = toOption(rawOption);
                  <mat-option [value]="option.key">{{ option.value }}</mat-option>
                }
              </mat-select>
              @if (formGroup.controls[field.key].errors !== null && submitted) {
                <mat-error>{{ 'COMMON.REQUIRED' | translate }}!</mat-error>
              }
            </mat-form-field>
          }
          @case ('checkbox') {
            @let checkboxInvalid = formGroup.controls[field.key].errors !== null && submitted;
            <div class="field-group" [class.invalid]="checkboxInvalid">
              <section class="checkbox-row">
                <mat-checkbox [formControlName]="field.key" [required]="field.required" [color]="checkboxInvalid ? 'warn' : 'primary'"></mat-checkbox>
                <mat-label>{{ field.name }}</mat-label>
              </section>
              @if (checkboxInvalid) {
                <p class="required-label">{{ 'COMMON.REQUIRED' | translate }}!</p>
              }
            </div>
          }
          @case ('calendar') {
            <mat-form-field>
              <mat-label>{{ field.name }}</mat-label>
              <input [required]="field.required" [min]="minDate" [max]="maxDate" [formControlName]="field.key" matInput [matDatepicker]="picker" [matDatepickerFilter]="getFilteredDates" readonly (click)="picker.open()">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker [touchUi]="true" disabled="false"></mat-datepicker>
              @if (formGroup.controls[field.key].errors !== null && submitted) {
                <mat-error>{{ 'COMMON.REQUIRED' | translate }}!</mat-error>
              }
            </mat-form-field>
          }
          @default {
            <mat-form-field>
              <mat-label>{{ field.name }}</mat-label>
              <input matInput [type]="field.type" [required]="field.required" [formControlName]="field.key" [attr.pattern]="field.pattern?.regex" [attr.placeholder]="field.placeholder">
              @let controlErrors = formGroup.controls[field.key].errors;
              @if (controlErrors && submitted) {
                <mat-error>
                  @if (controlErrors.pattern) {
                    {{ field?.pattern?.error }}
                  } @else if (controlErrors.backend) {
                    {{ controlErrors.backend }}
                  } @else if (controlErrors.email) {
                    {{ 'COMMON.INVALID_EMAIL' | translate }}
                  } @else if (controlErrors.required) {
                    {{ 'COMMON.REQUIRED' | translate }}!
                  }
                </mat-error>
              }
            </mat-form-field>
          }
        }
      }

      <button class="btn" type="submit" data-testid="order-form-submit" [disabled]="loading">
        {{ 'ACTIONS.SUBMIT' | translate }}
      </button>
    </form>
  }
</div>

<app-loader-overlay [active]="loading" />
